import React, { useEffect, useState } from "react";
import SifreInput from '../../../components/SifreInput';
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import { UserService } from "../../../services/UserService";
import { AddUserResponse } from "../../../models/response/user/AddUserResponse";
import { GetUserByIdResponse } from "../../../models/response/user/GetUserByIdResponse";
import CustomTextInput from "../../../components/CustomTextInput";
import { useMask } from "@react-input/mask";
import { CompanyService } from "../../../services/CompanyService";
import CustomMultiSelect, { CustomMultiSelectModel } from "../../../components/CustomMultiSelect";
import { RoleService } from "../../../services/RoleService";
import CustomSwitch from "../../../components/CustomSwitch";
import { DriverService } from "../../../services/DriverService";
import { PersonnelService } from "../../../services/PersonnelService";
import { kullaniciFormuSifreHatasi, SIFRE_EN_AZ_UZUNLUK } from '../../../helpers/sifreKurali';

const UserAdd = () => {
    const navigate = useNavigate();
    const pageName = "Ayarlar > Kullanıcı Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const phoneRef = useMask({ mask: '(___) ___-__-__', replacement: { _: /\d/ } });

    const [userId, setUserId] = useState<string | undefined>(undefined);
    const [nameSurname, setNameSurname] = useState<string | undefined>(undefined);
    const [username, setUsername] = useState<string | undefined>(undefined);
    const [password, setPassword] = useState<string | undefined>(undefined);
    const [email, setEmail] = useState<string | undefined>(undefined);
    const [phone, setPhone] = useState<string | undefined>(undefined);
    const [selectedCompany, setSelectedCompany] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedRoles, setSelectedRoles] = useState<CustomMultiSelectModel[]>([]);

    // Roller kullanıcının seçilen şirketine göre gelir (08.10.2026): ekranda seçili firma EbbeDev iken MERS GRUP
    // kullanıcısına EbbeDev rolü verilmişti; o role eklenen her sayfa kullanıcıya da gidiyordu.
    const rolleriGetir = () => {
        if (!selectedCompany)
            return Promise.resolve({ isSuccess: false, message: 'Önce şirketi seçiniz.' });

        return RoleService.getRoleList(selectedCompany.value);
    }

    // Şirket değişince önceki şirketin rolleri geçersiz kalır: seçili roller temizlenir.
    const sirketDegisti = (company: CustomSingleSelectModel | undefined) => {
        if (selectedRoles.length > 0 && company?.value !== selectedCompany?.value) {
            setSelectedRoles([]);
            toast('Şirket değişti; roller temizlendi, yeni şirketin rollerinden seçiniz.');
        }

        setSelectedCompany(company);
    }

    const [isDriver, setIsDriver] = useState(false);
    const [selectedDriver, setSelectedDriver] = useState<CustomSingleSelectModel | undefined>(undefined);

    // Depo personeli bağlantısı (QR mesai, Faz 1b): sürücü gibi seçilir; ikisi birden seçilebilir.
    const [isPersonnel, setIsPersonnel] = useState(false);
    const [selectedPersonnel, setSelectedPersonnel] = useState<CustomSingleSelectModel | undefined>(undefined);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetUserByIdResponse = await UserService.getUserById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setUserId(response.data.userId);
                setNameSurname(response.data.userNameSurname);
                setUsername(response.data.userUsername);
                setEmail(response.data.userEmail);
                setPhone(response.data.userPhone);
                setSelectedCompany(response.data.userCompany && response.data.userCompany.companyId && response.data.userCompany.companyName ? { label: response.data.userCompany.companyName, value: response.data.userCompany.companyId } : undefined)
                setSelectedRoles(!response.data.userRoles ? [] : response.data.userRoles.map(function (x) {
                    return { label: x.roleName, value: x.roleId }
                }));

                if (response.data.driverId && response.data.driverName) {
                    setIsDriver(true);
                    setSelectedDriver({ label: response.data.driverName, value: response.data.driverId })
                }

                if (response.data.personnelId && response.data.personnelName) {
                    setIsPersonnel(true);
                    setSelectedPersonnel({ label: response.data.personnelName, value: response.data.personnelId })
                }

            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveUser = async () => {
        try {
            if (Helpers.isEmpty(nameSurname))
                toast.error('Ad Soyad alanını doldurunuz!')
            else if (Helpers.isEmpty(username))
                toast.error('Kullanıcı Adı alanını doldurunuz!')
            else if (Helpers.isEmpty(email))
                toast.error('E-Posta alanını doldurunuz!')
            else if (Helpers.isEmpty(phone))
                toast.error('Telefon alanını doldurunuz!')
            else if (kullaniciFormuSifreHatasi(!Helpers.isEmpty(userId), password))
                toast.error(kullaniciFormuSifreHatasi(!Helpers.isEmpty(userId), password)!)
            else if (!Helpers.isEmpty(email) && email && !Helpers.validateEmail(email))
                toast.error('Lütfen geçerli bir email adresi giriniz!')
            else if ((!Helpers.isEmpty(phone) && phone && phone.length < 15))
                toast.error('Lütfen geçerli bir telefon numarası giriniz!')
            else if (!selectedCompany)
                toast.error('Şirket alanını doldurunuz!')
            else if (selectedRoles.length == 0)
                toast.error('En az bir Rol seçiniz!')
            else if (isDriver && !selectedDriver)
                toast.error('Sürücü alanı zorunludur!')
            else if (isPersonnel && !selectedPersonnel)
                toast.error('Personel alanı zorunludur!')
            else {
                dispatch(storeActivityIndicator(true));

                var response: AddUserResponse = await UserService.addUser(userId, nameSurname, email, phone, username, password, selectedCompany.value, selectedRoles.map(x => x.value), selectedDriver?.value, selectedPersonnel?.value);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                // Duzenlemede yeni sifre yazildiysa kullanicinin acik oturumlari sunucuda dusuruldu.
                toast.success(!Helpers.isEmpty(userId) && !Helpers.isEmpty(password)
                    ? response.message + ' Yeni şifre kaydedildi; kullanıcının açık oturumları kapatıldı.'
                    : response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <div className='row'>
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Ad Soyad</label>
                                            <CustomTextInput value={nameSurname} setValue={setNameSurname} />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">E-Posta</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={email} onChange={(e) => setEmail(e.target.value)} type="text" className="form-control form-control-solid" />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Roller</label>

                                            <CustomMultiSelect
                                                onChange={setSelectedRoles}
                                                selectedValues={selectedRoles}
                                                onMenuOpen={rolleriGetir}
                                                labelName='name'
                                                valueName='roleId'
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Kullanıcı Adı</label>
                                            <CustomTextInput value={username} setValue={setUsername} />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Telefon</label>
                                            <input ref={phoneRef} style={{ border: '1px solid #F1F1F4' }} value={phone} onChange={(e) => setPhone(e.target.value)} className="form-control form-control-solid" />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Sürücü</label>

                                            <Box flexDirection='row'>
                                                <Box width='80px'>
                                                    <CustomSwitch
                                                        isActive={isDriver}
                                                        setIsActive={() => {
                                                            var newVal = !isDriver;

                                                            if (!newVal)
                                                                setSelectedDriver(undefined);

                                                            setIsDriver(newVal);
                                                        }}
                                                    />
                                                </Box>
                                                <Box ml='15px' flexGrow={1}>
                                                    <CustomSingleSelect
                                                        disabled={!isDriver}
                                                        selectedValue={selectedDriver}
                                                        onChange={setSelectedDriver}
                                                        onMenuOpen={() => DriverService.getDriverList()}
                                                        labelName='nameSurname'
                                                        valueName='driverId'
                                                    />

                                                </Box>
                                            </Box>
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div>
                                            {/* Mevcut sifre gosterilemez (geri cevrilemez ozet olarak saklanir); duzenlemede yeni sifre belirlenir. */}
                                            <label htmlFor="kullaniciSifre" className={"form-label" + (Helpers.isEmpty(userId) ? " required" : "")}>{Helpers.isEmpty(userId) ? 'Şifre' : 'Yeni Şifre'}</label>
                                            <SifreInput id="kullaniciSifre" autoComplete="new-password" placeholder={Helpers.isEmpty(userId) ? `En az ${SIFRE_EN_AZ_UZUNLUK} karakter` : 'Değiştirmeyecekseniz boş bırakın'} style={{ border: '1px solid #F1F1F4' }} value={password ?? ''} onChange={(e) => setPassword(e.target.value)} className="form-control form-control-solid" />
                                        </div>

                                        <div className='mt-5'>
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Şirket</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedCompany}
                                                onChange={sirketDegisti}
                                                onMenuOpen={[
                                                    () => CompanyService.getCompanyList({ isCompany: true })
                                                ]}
                                                labelName='name'
                                                valueName='companyId'
                                            />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Personel</label>

                                            <Box flexDirection='row'>
                                                <Box width='80px'>
                                                    <CustomSwitch
                                                        isActive={isPersonnel}
                                                        setIsActive={() => {
                                                            var newVal = !isPersonnel;

                                                            if (!newVal)
                                                                setSelectedPersonnel(undefined);

                                                            setIsPersonnel(newVal);
                                                        }}
                                                    />
                                                </Box>
                                                <Box ml='15px' flexGrow={1}>
                                                    <CustomSingleSelect
                                                        disabled={!isPersonnel}
                                                        selectedValue={selectedPersonnel}
                                                        onChange={setSelectedPersonnel}
                                                        onMenuOpen={() => PersonnelService.getPersonnelList(undefined, true)}
                                                        labelName='nameSurname'
                                                        valueName='personnelId'
                                                    />
                                                </Box>
                                            </Box>
                                        </div>
                                    </div>
                                </div>

                                <div className="text-muted fs-7 mt-5">
                                    Girişi roller belirler: <b>Mobil</b> rolü olan kullanıcı mobil uygulamaya, Mobil dışında bir rolü olan kullanıcı web'e girer; ikisi birlikte verilebilir.
                                    {' '}Mobil uygulama için ayrıca sürücü ya da personel seçilmeli: sürücü kaydı Görevlerim'i (seferler), personel kaydı QR mesaiyi açar; ikisi birden seçilebilir.
                                    {' '}"Mobil" rolü adıyla tanınır; Roller ekranında adını değiştirmeyin.
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveUser}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default UserAdd;